import React from "react";
import classes from "./AddUserModal.module.scss";
import Modal from "../../../../components/Common/Modal/Modal";
import { groupManagement } from "../../../../utils/mainTabs/admin/groupManagement/groupManagement";

const AddUserModal = ({
  addUserModal,
  setAddUserModal,
  navigate,
  tenantName,
  groupData,
}) => {
  const handleSubmit = () => {
    localStorage.setItem("groupName", groupData?.[0]?.Name);
    localStorage.setItem("manageUsersCount", groupData?.[0]?.UserGroupCount);
    localStorage.setItem(
      "manageSubgroupsCount",
      groupData?.[0]?.UserSubGroups?.length
    );
    navigate(
      `${groupManagement?.path(tenantName)}/manageUsers/${
        groupData?.[0]?.UserGroupId
      }`
    );
    setAddUserModal(!addUserModal)
  };

  return (
    <Modal
      handleSubmit={handleSubmit}
      isOpen={addUserModal}
      heading={"Shotclasses Message"}
      toggle={() => setAddUserModal(!addUserModal)}
      buttonLabel1={"Yes"}
      buttonLabel2={"No"}
      width={"46.2"}
      height={"26.9"}
    >
      <div className={classes.addUserModal}>
        <div>Do you want to add users now?</div>
      </div>
    </Modal>
  );
};

export default AddUserModal;
